import React from "react";

import { SimplePatientPageLayout } from "features/patients/components/SimplePatientPageLayout/SimplePatientPageLayout";

import { BaselineDetails } from "./components/BaselineDetails/BaselineDetails.jsx";
import { BaselineHistory } from "./components/BaselineHistory/BaselineHistory.jsx";
import s from "./PatientBaselinePage.module.css";

// Its own tab rather than a widget buried on Details — baseline readings
// accumulate as a history (weight, BP, bloods, etc.), so they need the room
// a dedicated page gives the current-values card, the history table, and
// the trend charts, instead of squeezing all three into one column.
const PatientBaselinePage = () => {
  return (
    <SimplePatientPageLayout>
      <div className={s.wrapper}>
        <BaselineDetails />
        <BaselineHistory />
      </div>
    </SimplePatientPageLayout>
  );
};

export { PatientBaselinePage };
